import React from "react";
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import SectionHeader from "@dhn/components/molecules/section-header";
import PhoneNumberInput from "../../../@dhn/components/molecules/phone-number-input";
import CommercialFields from "./CommercialFields";
import LocationFields from "./LocationFields";

const PhysicalPersonFields = ({
  form,
  isSubmitting,
  provinces,
  physicalMunicipalities,
  physicalSectors,
  legalUsername,
  inlineErrors,
  identityValidation,
  onChange,
  showInlineError,
  primaryDocumentLabel,
  primaryDocumentValue,
}) => (
  <Card className="fade-in-up mb-3">
    <CardBody>
      <SectionHeader
        icon={form.isMedical ? "fa-user-md" : "fa-user"}
        title={
          form.isMedical
            ? "En caso de ser Persona Física - Médico"
            : "En caso de ser Persona Física - Usuario"
        }
      />
      <CommercialFields
        form={form}
        inlineErrors={inlineErrors}
        identityValidation={identityValidation}
        onChange={onChange}
        showInlineError={showInlineError}
      />
      <Row form>
        <Col md={4}>
          <FormGroup>
            <Label>
              {primaryDocumentLabel}{" "}
              <span className="required-mark">*</span>
            </Label>
            <Input
              value={primaryDocumentValue}
              disabled={true}
              readOnly
              placeholder="documento validado"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md={3}>
          <FormGroup>
            <Label>
              Primer Nombre <span className="required-mark">*</span>
            </Label>
            <Input
              name="physical_first_name"
              autoComplete="section-physical name"
              invalid={Boolean(inlineErrors.physicalFirstName)}
              value={form.physicalFirstName}
              onChange={(event) =>
                onChange(
                  "physicalFirstName",
                  event.target.value,
                )
              }
              placeholder="campo obligatorio"
            />
            {showInlineError("physicalFirstName")}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Segundo Nombre</Label>
            <Input
              name="physical_middle_name"
              autoComplete="section-physical additional-name"
              value={form.physicalMiddleName}
              onChange={(event) =>
                onChange(
                  "physicalMiddleName",
                  event.target.value,
                )
              }
              placeholder="opcional"
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>
              Primer Apellido <span className="required-mark">*</span>
            </Label>
            <Input
              name="physical_last_name"
              autoComplete="section-physical family-name"
              invalid={Boolean(inlineErrors.physicalLastName)}
              value={form.physicalLastName}
              onChange={(event) =>
                onChange("physicalLastName", event.target.value)
              }
              placeholder="campo obligatorio"
            />
            {showInlineError("physicalLastName")}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Segundo Apellido</Label>
            <Input
              name="physical_last_name2"
              autoComplete="new-password"
              value={form.physicalLastName2}
              onChange={(event) =>
                onChange(
                  "physicalLastName2",
                  event.target.value,
                )
              }
              placeholder="opcional"
            />
          </FormGroup>
        </Col>
      </Row>

      <Row form>
        <Col md={3}>
          <FormGroup>
            <Label>
              Celular <span className="required-mark">*</span>
            </Label>
            <PhoneNumberInput
              value={form.physicalCellphone}
              onChange={(value) =>
                onChange("physicalCellphone", value)
              }
              placeholder="campo obligatorio"
            />
            {showInlineError("physicalCellphone")}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Teléfono</Label>
            <PhoneNumberInput
              value={form.physicalPhone}
              onChange={(value) =>
                onChange("physicalPhone", value)
              }
              placeholder="Ingrese telefono"
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Teléfono 2</Label>
            <PhoneNumberInput
              value={form.physicalPhone2}
              onChange={(value) => onChange("physicalPhone2", value)}
              placeholder="Ingrese telefono adicional"
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>
              Correo electrónico <span className="required-mark">*</span>
            </Label>
            <Input
              type="email"
              name="physical_email"
              autoComplete="section-physical email"
              invalid={Boolean(inlineErrors.physicalEmail)}
              value={form.physicalEmail}
              onChange={(event) =>
                onChange("physicalEmail", event.target.value)
              }
              placeholder="campo obligatorio"
            />
            {showInlineError("physicalEmail")}
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col>
          <FormGroup>
            <Label>
              Dirección <span className="required-mark">*</span>
            </Label>
            <Input
              name="physical_address"
              autoComplete="section-physical street-address"
              invalid={Boolean(inlineErrors.physicalAddress)}
              value={form.physicalAddress}
              onChange={(event) =>
                onChange("physicalAddress", event.target.value)
              }
              placeholder="campo obligatorio"
            />
            {showInlineError("physicalAddress")}
          </FormGroup>
        </Col>
      </Row>

      <LocationFields
        prefix="physical"
        form={form}
        provinces={provinces}
        municipalities={physicalMunicipalities}
        sectors={physicalSectors}
        inlineErrors={inlineErrors}
        onChange={onChange}
        showInlineError={showInlineError}
        disabled={isSubmitting}
      />

      <Row form>
        <Col md={form.isMedical ? 6 : 12}>
          <FormGroup>
            <Label>Usuario</Label>
            <Input
              value={legalUsername}
              readOnly
              placeholder="Se sugiere al validar datos"
            />
          </FormGroup>
        </Col>
        {form.isMedical && (
          <Col md={6}>
            <FormGroup>
              <Label>
                Exequátur <span className="required-mark">*</span>
              </Label>
              <Input
                invalid={Boolean(inlineErrors.physicalExequatur)}
                value={form.physicalExequatur}
                onChange={(event) =>
                  onChange(
                    "physicalExequatur",
                    event.target.value,
                  )
                }
                placeholder="campo obligatorio"
              />
              {showInlineError("physicalExequatur")}
            </FormGroup>
          </Col>
        )}
      </Row>
    </CardBody>
  </Card>
);

export default PhysicalPersonFields;
